import RadialProgressChart from "@/components/charts/RadialProgressChart";
import { useLiveWireStore } from "@/stores/livewire";
import { useShallow } from "zustand/react/shallow";

const chartHeight = {
  sm: 150,
  md: 220,
  lg: 300,
  xxl: 700,
  fill: 300,
};

function DailyQuotaProgressWidget({
  chartId = "daily-progress-chart",
  size = "fill",
}) {

  const [
    daily,
    // getDailyStats,
    // opsDailyTargetAchievedAt,
    // setOpsDailyTargetAchievedAt,
  ] = useLiveWireStore(
    useShallow((state) => [
      state.daily,
      // state.getDailyStats,
      // state.opsDailyTargetAchievedAt,
      // state.setOpsDailyTargetAchievedAt,
    ])
  );

  // useEffect(() => {
  //   if (!daily?.sent_to_qa_target) return;
  //   if (
  //     daily?.sent_to_qa_target === daily?.sent_to_qa &&
  //     !opsDailyTargetAchievedAt
  //   ) {
  //     setOpsDailyTargetAchievedAt();
  //   }
  // }, [daily?.sent_to_qa_target, daily?.sent_to_qa, opsDailyTargetAchievedAt]);

  console.log(daily)

  return (
    <div className={`apps-closed-by-day widget widget-${size}`}>
      <div className="card card-rounded">
        <div className="d-flex justify-content-between p-3 pb-0">
          <div className="d-flex align-items-center">
            <span className="bi bi-bullseye text-orange me-2 fs-24"></span>
            <span className="text-black fw-bold fs-18">Daily Target</span>
          </div>
          <div className="px-2 py-1 ">
            <span className="text-secondary fs-18 fw-bold">
              {daily?.sent_to_qa || 0}
            </span>
            <span className="text-dark fs-16"> / </span>
            <span className="text-orange fs-14 fw-bold">
              {daily?.sent_to_qa_target || 0}
            </span>
          </div>
        </div>
        <div className="card-body pt-0 overflow-hidden">
          <RadialProgressChart
            id={chartId}
            height={chartHeight[size]}
            series={[
              Math.round(
                (daily?.sent_to_qa / daily?.sent_to_qa_target) * 100
              ) || 0,
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default DailyQuotaProgressWidget;
